import * as actions from "../actions/actionTypes/index";

const MatchOfTheDayGamesReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.MATCH_OF_THE_DAY_GAMES_LIST_UPDATE_RECEIVED:
            return {
                ...state,
                [action.key]: {
                    ...state.games,
                    ...action.payload
                }
            };
        case actions.RESET_MATCH_OF_THE_DAY_GAMES_LIST:
            return action.key
                ? {
                    [action.key]: undefined
                }
                : {

                };
        default :
            return state;
    }
};

export default MatchOfTheDayGamesReducer;
